// extracted by mini-css-extract-plugin
module.exports = {"Box":"HeightMapToggle_Box__1N3YE","Paper":"HeightMapToggle_Paper__1Xz-B","Disabled":"HeightMapToggle_Disabled__1BNKL"};